<template>
    <div class="use-terms-filter">
      <nestable-tree id="useTermsFilter"
                     :value="value"
                     :options="useTerms"
                     :normalizer="normalizer"
                     :no-options-text="$t('message.automation.message.noUseTerms')"
                     :placeholder="$t('message.automation.message.useTerms')"
                     @input="emitInput">
        <div slot="option-label"
             slot-scope="{ node }">
          <filter-local-tree-item :node="node" :showIcons="false"/>
        </div>
      </nestable-tree>
    </div>
  </template>
  
  <script>
  import FilterLocalTreeItem from "@/components/filters/local/tree/item/FilterLocalTreeItem";
  import NestableTree from "@/components/generic/nestable/tree/NestableTree";
  
  export default {
    components: {
      NestableTree,
      FilterLocalTreeItem,
    },
  
    data() {
      return {
        useTermsLoaded: false,
        useTerms: [],
        normalizer(node) {
          return {
            id: node.id,
            label: node.name,
            children: node.children,
          };
        },
      };
    },
  
    props: {
      value: {
        type: Array,
        default() {
          return [];
        },
      },
      step: {
        type: Object,
      },
      automationId: {
        type: String,
      },
    },
  
    watch: {},

    computed: {
        establishmentId() {
            return this.$store.state.users.user.accountId
        }
    },
  
    async created() {
      await this.loadUseTerms();
    },
  
    methods: {
      emitInput(val) {
        this.$emit("input", val);
      },      
      async loadUseTerms() {
        try {
          this.useTermsLoaded = false;
  
          const list = await this.$api.usageTerms.getUseTermsOptIn({userId: this.establishmentId})           
  
          this.useTerms = [...list]; 
         
          this.useTermsLoaded = true;
        } catch (error) {
          console.log(error);
        }
      },      
    },
  
    beforeDestroy() {},
  
    mixins: [],
  
    mounted() {},
  };
  </script>
  
  <style lang="scss" scoped>
    #useTermsFilter {
        ::v-deep .vue-treeselect__list-item {
            margin-bottom: 5px;
        }
        ::v-deep .vue-treeselect__label-container {
            display: flex;
            gap: 8px;       

        }
        ::v-deep .vue-treeselect__checkbox-container {
            padding-top: 4px;
        }
    }
  </style>
  